import mitt from "mitt";
type EventBus = {
    resetViewer: boolean;
    openChat: chatMessage
}
export const eventBus = mitt<EventBus>();
export type chatMessage = {
    message: string;
    context?: object;
}